export type HeatAgeLevel = "Watch" | "Warning" | "Critical";

export const HEAT_AGE_COLORS: Record<
	HeatAgeLevel,
	{ backgroundColor: string; color: string }
> = {
	Watch: { backgroundColor: "#fbefb9", color: "#71531f" },
	Warning: { backgroundColor: "#fbd9b0", color: "#7c2d12" },
	Critical: { backgroundColor: "#f6c6ca", color: "#7f1d1d" },
};

export const HEAT_AGE_OK_COLORS = {
	backgroundColor: "#eeeeee",
	color: "#666666",
};
